/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalGetReportFormInstancesByRecipientIdResponseResultsInner } from './SupplementalGetReportFormInstancesByRecipientIdResponseResultsInner';
import {
    SupplementalGetReportFormInstancesByRecipientIdResponseResultsInnerFromJSON,
    SupplementalGetReportFormInstancesByRecipientIdResponseResultsInnerFromJSONTyped,
    SupplementalGetReportFormInstancesByRecipientIdResponseResultsInnerToJSON,
} from './SupplementalGetReportFormInstancesByRecipientIdResponseResultsInner';

/**
 * 
 * @export
 * @interface SupplementalGetReportFormInstancesByRecipientIdResponse
 */
export interface SupplementalGetReportFormInstancesByRecipientIdResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByRecipientIdResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByRecipientIdResponse
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByRecipientIdResponse
     */
    next?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByRecipientIdResponse
     */
    previous?: number | null;
    /**
     * 
     * @type {Array<SupplementalGetReportFormInstancesByRecipientIdResponseResultsInner>}
     * @memberof SupplementalGetReportFormInstancesByRecipientIdResponse
     */
    results?: Array<SupplementalGetReportFormInstancesByRecipientIdResponseResultsInner>;
}

/**
 * Check if a given object implements the SupplementalGetReportFormInstancesByRecipientIdResponse interface.
 */
export function instanceOfSupplementalGetReportFormInstancesByRecipientIdResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalGetReportFormInstancesByRecipientIdResponseFromJSON(json: any): SupplementalGetReportFormInstancesByRecipientIdResponse {
    return SupplementalGetReportFormInstancesByRecipientIdResponseFromJSONTyped(json, false);
}

export function SupplementalGetReportFormInstancesByRecipientIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalGetReportFormInstancesByRecipientIdResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SupplementalGetReportFormInstancesByRecipientIdResponseResultsInnerFromJSON)),
    };
}

export function SupplementalGetReportFormInstancesByRecipientIdResponseToJSON(value?: SupplementalGetReportFormInstancesByRecipientIdResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'limit': value.limit,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SupplementalGetReportFormInstancesByRecipientIdResponseResultsInnerToJSON)),
    };
}

